<template>
  <div class="grid grid-cols-3 gap-6 custom:grid-cols-1">
    <div class="flex-1">
      <div
        class="rounded-xl shadow-card"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
      >
        <div
          class="px-4 py-3.5 border-b"
          :class="mode === 'dark' ? 'border-dark-50' : ''"
        >
          <span class="font-semibold text-[17px] leading-none"
            >Recent keyword discovery</span
          >
        </div>
        <div class="w-full overflow-x-auto without-scrollbar">
          <table class="form-table w-full">
            <tbody
              class="divide-y bg-opacity-40"
              :class="
                mode === 'dark'
                  ? 'bg-dark-70 divide-dark-50'
                  : 'bg-white-100 divide-gray-100'
              "
            >
              <tr v-for="(report, key) in props.KDreports" :key="key" s>
                <td>
                  <RouterLink
                    :to="{
                      name: 'KeywordPlannerDetail',
                      params: { uuid: report.planner_uuid },
                    }"
                    class="font-medium hover:text-primary-100 text-wrap inline-block"
                    >{{ report.text || report.website_url }}</RouterLink
                  >
                </td>
                <td>
                  <div class="flex items-center gap-2">
                    <CalendarDays :size="18" :stroke-width="1.75" />
                    {{ formatDate(report.created_at) }}
                  </div>
                </td>
                <td>
                  <span class="lowercase">{{ statuses[report.status] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="border-t-4 rounded-bl-xl rounded-br-xl"
          :class="
            mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100 '
          "
        >
          <div class="flex items-center gap-2 px-4 py-3 justify-end">
            <button
              class="button primary-button small-button"
              @click="$router.push({ name: 'KeywordPlanner' })"
            >
              <LayoutList :size="20" :stroke-width="1.75" />
              Start New Keyword Discovery
            </button>
            <button
              class="button primary-button small-button"
              @click="$router.push({ name: 'KeywordPlanner' })"
            >
              <Eye :size="20" :stroke-width="1.75" class="mt-[1px]" />
              View all
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1">
      <div
        class="rounded-xl shadow-card"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
      >
        <div
          class="px-4 py-3.5 border-b"
          :class="mode === 'dark' ? 'border-dark-50' : ''"
        >
          <span class="font-semibold text-[17px] leading-none"
            >Recent keyword spy reports</span
          >
        </div>
        <div class="w-full overflow-x-auto without-scrollbar">
          <table class="form-table w-full">
            <tbody
              class="divide-y bg-opacity-40"
              :class="
                mode === 'dark'
                  ? 'bg-dark-70 divide-dark-50'
                  : 'bg-white-100 divide-gray-100'
              "
            >
              <tr v-for="(report, key) in props.reports" :key="key">
                <td>
                  <RouterLink
                    :to="{
                      name: 'serp-report-ta',
                      params: { uuid: report.uuid },
                    }"
                    class="font-medium hover:text-primary-100 text-wrap inline-block"
                    >{{ report.query }}</RouterLink
                  >
                </td>
                <td>
                  <div class="flex items-center gap-2">
                    <CalendarDays :size="18" :stroke-width="1.75" />
                    {{ formatDate(report.created_at) }}
                  </div>
                </td>
                <td>{{ report.result_count }} results</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="border-t-4 rounded-bl-xl rounded-br-xl"
          :class="
            mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100 '
          "
        >
          <div class="flex items-center gap-2 px-4 py-3 justify-end">
            <button
              class="button primary-button small-button"
              @click="$router.push({ name: 'serp-keyword-spy' })"
            >
              <TextSearch :size="20" :stroke-width="1.75" />
              Start New Keyword Spy Report
            </button>
            <button
              class="button primary-button small-button"
              @click="$router.push({ name: 'reports' })"
            >
              <Eye :size="20" :stroke-width="1.75" class="mt-[1px]" />
              View all
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1">
      <div
        class="rounded-xl shadow-card"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
      >
        <div
          class="px-4 py-3.5 border-b"
          :class="mode === 'dark' ? 'border-dark-50' : ''"
        >
          <span class="font-semibold text-[17px] leading-none">Projects</span>
        </div>
        <div class="w-full overflow-x-auto without-scrollbar">
          <table class="form-table w-full">
            <tbody
              class="divide-y bg-opacity-40"
              :class="
                mode === 'dark'
                  ? 'bg-dark-70 divide-dark-50'
                  : 'bg-white-100 divide-gray-100'
              "
            >
              <tr v-for="(project, key) in props.projects" :key="key">
                <td>
                  <RouterLink
                    :to="{
                      name: 'reports',
                      query: { project: project.uuid },
                    }"
                    class="font-medium hover:text-primary-100 text-wrap inline-block"
                    >{{ project.name }}</RouterLink
                  >
                </td>
                <td>
                  <div class="flex items-center gap-2">
                    <CalendarDays :size="18" :stroke-width="1.75" />
                    {{ formatDate(project.created_at) }}
                  </div>
                </td>
                <td>{{ project.search_count }} search</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="border-t-4 rounded-bl-xl rounded-br-xl"
          :class="
            mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100 '
          "
        >
          <div class="flex items-center gap-2 px-4 py-3 justify-end">
            <button
              class="button primary-button small-button"
              @click="$router.push({ name: 'projects' })"
            >
              <FolderOpenDot :size="20" :stroke-width="1.75" />
              Add New Project
            </button>
            <button
              class="button primary-button small-button"
              @click="$router.push({ name: 'projects' })"
            >
              <Eye :size="20" :stroke-width="1.75" class="mt-[1px]" />
              View all
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { formatDate } from "../libs";
import {
  CalendarDays,
  Eye,
  FolderOpenDot,
  LayoutList,
  TextSearch,
} from "lucide-vue-next";
interface Props {
  reports: any;
  KDreports: any;
  projects: any;
  mode?: string;
}
const props = withDefaults(defineProps<Props>(), { mode: "dark" });
const statuses = ref({
  10: "Pending",
  20: "Success",
  30: "Failure",
});
</script>
